module.exports = __webpack_public_path__ + "static/media/8.2ecf7d48.jpg";